<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="物品名称" prop="name">
            <Input class="widK" :disabled="action=='detail'" v-model.trim="formValidate.name" placeholder="物品名称" />
          </FormItem>
          <FormItem label="积分值" prop="integralBranch">
            <Input class="widK" :disabled="action=='detail'" v-model.trim="formValidate.integralBranch" placeholder="积分值" />
          </FormItem>
          <FormItem label="总数量" prop="totalQuantity" v-if="action!='edit'">
            <Input class="widK" :disabled="action=='detail'" v-model.trim="formValidate.totalQuantity" placeholder="总数量" />
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="primary" v-if="display" @click="submit()">确定</Button>
        <Button type="default" v-if="display" style="margin:0 16px" @click="handleReset">重置</Button>
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "integralGoodsItemAdd",
  data() {
    const validateNum = (rule, value, callback) => {
      if (!value) { callback(new Error("请输入值")); return; }
      if (!/^\d+$/.test(value)) { callback(new Error("请输入正整数")); return; }
      callback();
    };
    return {
      display: true, formValidate: {},
      ruleValidate: {
        name: [{ required: true, message: "请填写物品名称", trigger: "blur" }],
        integralBranch: [{ required: true, validator: validateNum }],
        totalQuantity: [{ required: true, validator: validateNum }],
      },
    };
  },
  created() { this.init(); },
  methods: {
    init() {
      if (this.$byStoreHas(this.$route.name)) {
        this.action = this.$byStoreGet(this.$route.name).action;
        this.id = this.$byStoreGet(this.$route.name).id || "";
      } else { this.$router.push({ name: "404" }); }
      if (this.action == "edit" || this.action == "detail") { this.getParams(this.id); if (this.action == "detail") this.display = false; }
    },
    getParams(id) {
      this.$http.get("/api/tIntegralGoods/get", { params: { id } }).then(r => { this.formValidate = r.data.data; });
    },
    submit() {
      this.$refs.formValidate.validate(v => {
        if (!v) return;
        let p = JSON.parse(JSON.stringify(this.formValidate));
        let url = this.action == "edit" ? "/api/tIntegralGoods/update" : "/api/tIntegralGoods/save";
        this.$http.post(url, p).then(() => { this.$Message.success("保存成功"); this.back(); });
      });
    },
    handleReset() { this.$refs.formValidate.resetFields(); },
    back() {
      this.$store.commit("app/closePage", { vm: this, fromName: this.$route.name, toName: "integralGoodsItem" });
    },
  },
};
</script>
<style scoped>#content { width: 100%; } .disabled { pointer-events: none; }</style>
